module.exports = __webpack_public_path__ + "img/Trash.023ae15b.svg";